import { LiabilityTypeBuilder, LiabilityFormData, LiabilityRequestData } from './types';

import { format } from 'utils/date';
import { createLiability } from '../liabilities';
import { FIELDS } from '../../partials/Form/Form.types';

export class CreditCommitmentTypeBuilder implements LiabilityTypeBuilder {
  private saveData: LiabilityRequestData;
  private data: LiabilityFormData = createLiability();

  constructor() {
    this.saveData = {
      type: '',
      cardBalance: null,
      amount: null,
      commitmentEnds: null,
      isClearedBeforeLoanCompletes: null,
    };
  }

  set formData(value: LiabilityFormData) {
    this.data = value;
  }

  get formData() {
    return this.data;
  }

  getData() {
    return this.saveData;
  }

  setType() {
    return (this.saveData.type = this.formData[FIELDS.LIABILITY_TYPE]);
  }

  setAmount() {
    this.saveData.amount = this.formData[FIELDS.LIABILITY_AMOUNT];
  }

  setCreditCardBalance() {
    this.saveData.cardBalance = Number(this.formData[FIELDS.LIABILITY_CREDIT_CARD_BALANCE]);
  }

  setIsClearedBeforeLoanCompletes() {
    const val = this.formData[FIELDS.LIABILITY_IS_CLEARED_BEFORE_LOAN_COMPLETES];

    if (val !== null && typeof val !== 'undefined') {
      this.saveData.isClearedBeforeLoanCompletes = val;
    } else {
      this.saveData.isClearedBeforeLoanCompletes = null;
    }

    // this.saveData.isClearedBeforeLoanCompletes = typeof val === 'boolean' ? val : null;
  }

  setCommitmentEnd() {
    const commitementEnds = this.formData[FIELDS.LIABILITY_COMMITMENT_END_DATE];
    this.saveData.commitmentEnds = commitementEnds ? format(commitementEnds).fromViewToRequest() : null;
  }
}
